/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  AssignVirtualRoomDto,
  VirtualRoom,
  VirtualRoomsControllerAssignV1PathParameters,
  VirtualRoomsControllerFindAllV1200AllOf,
  VirtualRoomsControllerFindAllV1Params,
  VirtualRoomsControllerFindAllV1PathParameters,
  VirtualRoomsControllerFindCalendarAppointmentsV1200AllOf,
  VirtualRoomsControllerFindCalendarAppointmentsV1Params,
  VirtualRoomsControllerFindCalendarAppointmentsV1PathParameters,
  VirtualRoomsControllerFindOneV1PathParameters,
  VirtualRoomsControllerSubscribeCalendarsV1200,
  VirtualRoomsControllerSubscribeCalendarsV1PathParameters,
  VirtualRoomsControllerSyncCalendarV1200,
  VirtualRoomsControllerSyncCalendarV1PathParameters,
  VirtualRoomsControllerSyncV1200,
  VirtualRoomsControllerSyncV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class VirtualRoomsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get a paginated list of virtual rooms for this client
   */

  findAll<TData = VirtualRoomsControllerFindAllV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: VirtualRoomsControllerFindAllV1PathParameters,
    params?: VirtualRoomsControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get a single virtual room
   */

  findOne<TData = VirtualRoom>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: VirtualRoomsControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/${id}`);
  }
  /**
   * @summary Get a paginated list of calendar appointments for a single virtual room
   */

  findCalendarAppointments<TData = VirtualRoomsControllerFindCalendarAppointmentsV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: VirtualRoomsControllerFindCalendarAppointmentsV1PathParameters,
    params?: VirtualRoomsControllerFindCalendarAppointmentsV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/${id}/calendar-appointments`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Fetch this client's MS Teams rooms from Microsoft Graph and store/update them as virtual rooms
   */

  sync<TData = VirtualRoomsControllerSyncV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: VirtualRoomsControllerSyncV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/sync`, undefined);
  }
  /**
   * @summary Create a calendar-events subscription for every virtual room of this client that has none yet
   */

  subscribeCalendars<TData = VirtualRoomsControllerSubscribeCalendarsV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: VirtualRoomsControllerSubscribeCalendarsV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/calendar/subscriptions`, undefined);
  }
  /**
   * @summary Ensure a calendar-events subscription exists for this room and backfill its current bookings from Microsoft Graph
   */

  syncCalendar<TData = VirtualRoomsControllerSyncCalendarV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: VirtualRoomsControllerSyncCalendarV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/${id}/calendar/sync`, undefined);
  }
  /**
   * @summary Assign a virtual room to a Space of type Room
   */

  assign<TData = VirtualRoom>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: VirtualRoomsControllerAssignV1PathParameters,
    assignVirtualRoomDto: AssignVirtualRoomDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/clients/${clientId}/virtual-rooms/${id}/assign`, assignVirtualRoomDto);
  }
}
